import { formatarDocumento } from "@/utils/format-document";
import { formatarTelefone } from "@/utils/format-telefone";

import { ICliente } from "../interface";

function mapRemessasToTable(data: ICliente[]): Record<string, any>[] {
  return data?.map((cliente) => ({
    id: cliente.id,
    nome: cliente?.nome,
    situacao: cliente?.ativo ? "ativo" : "inativo",
    saldo_creditos: cliente?.creditos?.saldo || 0,
    email: cliente?.email,
    documento: formatarDocumento(cliente?.documento),
    telefone: formatarTelefone(cliente?.telefone),
    contato: cliente?.contato?.nome || "N/A",
    consultor: cliente?.consultor?.nome ?? "N/A",
    tipos_entrega: cliente?.tipos_entrega || null,
  }));
}

export { mapRemessasToTable };
